import extractPhoneCountryCode from "../extract-phone-country-code";

type errors = {
  phone?: string;
};
const ValidatePhone = (
  phoneNumber: string | null,
  knownCountryCode?: string
): errors => {
  const errors: errors = {};

  if (phoneNumber) {
    let cc: string;
    let rest: string;
    if (knownCountryCode) {
      cc = knownCountryCode;
      rest = phoneNumber.startsWith(knownCountryCode)
        ? phoneNumber.slice(knownCountryCode.length)
        : phoneNumber;
    } else {
      [cc, rest] = extractPhoneCountryCode(phoneNumber);
    }
    if (!cc || !validatePhoneNumber(cc, rest)) {
      errors.phone = "Invalid phone number";
    }
  } else {
    errors.phone = "Required";
  }
  return errors;
};

function validatePhoneNumber(country_code: string, number: string) {
  const val = number.trim().replace(/[^\d]/, "");
  let phoneLength = 10;
  if (country_code !== "+1") {
    phoneLength = 9;
  }
  const matches = val.match(/[0-9]/g);
  if (!matches || matches.length < phoneLength) {
    return false;
  }
  return true;
}

export default ValidatePhone;
